export default {"src":"/_next/static/media/Home_PWA.abfa1ca8.svg","height":80,"width":80};